<template>
  <section class="section">
    <div class="container-lg">

      <div class="section__header">
        <h1 class="section__title  section__title--lg">
          {{ in18['page_title'] }}
        </h1>
      </div><!-- /.section__header -->

      <div v-if="isNotEmptyCart()" class="row">

        <div class="col-xl-9  col-lg-8">

          <cart-items-list
              :cart="cart"
              :in18="in18"
              @update-cart="updateCart"
          />

          <template v-if="services.length">
            <services
                :cart="cart"
                :in-progress="inProgress"
                :in18="in18"
                :services="services"
                @update-cart="updateCart"
                @update-in-progress="updateInProgress"
            />
          </template>
        </div><!-- /.col -->

        <div class="col-xl-3  col-lg-4">

          <!--<cart-shipping-->
          <!--    :in18="in18"-->
          <!--    :cart="cart"-->
          <!--    :in-progress="inProgress"-->
          <!--    @update-cart="updateCart"-->
          <!--    @update-in-progress="updateInProgress"-->
          <!--/>-->

          <div class="h-max w-full sticky top-[161px]">
            <cart-summary
                :cart="cart"
                :checkout_route="checkout_route"
                :in18="in18"
            />
            <cart-coupon
                :cart="cart"
                :in-progress="inProgress"
                :in18="in18"
                @update-cart="updateCart"
                @update-in-progress="updateInProgress"
            />
          </div>

        </div><!-- /.col -->

      </div><!-- /.row -->

      <div v-else class="row">
        <div v-if="!inProgress" class="d-flex justify-content-center ml-4">
          <div>
            <img alt="" class="img m-auto mb-4" src="/shop/images/cart_empty.png" style="width: 80px;">
            <div class="section__text text-center mb-2">{{ in18['page_cart_is_empty'] }}</div>
            <a class="btn  btn--red  btn--block  btn--sm" href="/">
              {{ in18['page_continue_shopping_btn'] }}
            </a>
          </div>
        </div>
      </div>
    </div><!-- /.container -->
  </section><!-- /.section -->
</template>

<script>

import CartCoupon from '../components/cart/CartCoupon.vue';
import CartItemsList from '../components/cart/CartItemsList.vue';
import CartSummary from '../components/cart/CartSummary.vue';
import CartShipping from '../components/cart/CartShipping.vue';
import Services from "../components/cart/Services.vue";

export default {
  components: {
    'cart-coupon':     CartCoupon,
    'cart-items-list': CartItemsList,
    'cart-summary':    CartSummary,
    'cart-shipping':   CartShipping,
    'services':        Services,
  },
  props:      {
    in18:           {
      type: Object
    },
    checkout_route: {
      type: String
    },
  },
  data() {
    return {
      inProgress: true,
      cart:       {},
      services:   [],
    };
  },
  created() {
    this.fetchServices();
    this.fetchCart();
  },
  methods: {
    fetchCart() {
      axios.get('/api/cart/reset-data')
          .then((response) => {
            this.cart = response.data.cart;
            ga_view_cart_event(response.data.cart);
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
          })
          .finally(() => {
            this.inProgress = false;
          });
    },
    fetchServices() {
      axios.get('/api/product/services')
          .then((response) => {
            this.services = response.data;
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
          })
          .finally(() => {
            this.inProgress = false
          });
    },
    updateCart(newCart) {
      this.cart = newCart;
    },
    updateInProgress(inProgress) {
      this.inProgress = inProgress;
    },
    isNotEmptyCart() {
      return this.cart.hasOwnProperty('items') && this.cart.items.length > this.cart.item_services.length
    }
  }
};
</script>